import getStructureFieldValues from "./getStructureFieldValues";
import { hasDiscountParam } from "application/functions";

export default function formAdapter(form) {
  const sf = form?.structureFields ?? [];
  const garment = getStructureFieldValues(sf, "garment");
  garment.sf = getGarmentSf(garment.sf);
  const withDiscount = getStructureFieldValues(sf, "withDiscount")?.path || hasDiscountParam();

  const adaptedForm = {
    id: form.id,
    title: form.name,
    button: form.literalButton,
    name: getStructureFieldValues(sf, "name"),
    surname: getStructureFieldValues(sf, "surname"),
    email: getStructureFieldValues(sf, "email"),
    mobile: getStructureFieldValues(sf, "mobile"),
    address: getStructureFieldValues(sf, "address"),
    floor: getStructureFieldValues(sf, "floor"),
    region: getStructureFieldValues(sf, "region"),
    city: getStructureFieldValues(sf, "city"),
    postal_code: getStructureFieldValues(sf, "postal_code"),
    market: getStructureFieldValues(sf, "market"),
    paypal_transaction_id: getStructureFieldValues(sf, "paypal_transaction_id"),
    money: getStructureFieldValues(sf, "money"),
    language: getStructureFieldValues(sf, "language"),
    shipping_costs: getStructureFieldValues(sf, "shipping_costs"),
    accept_terms: getStructureFieldValues(sf, "accept_terms"),
    accept_service: getStructureFieldValues(sf, "accept_service"),
    read_terms: getStructureFieldValues(sf, "readTerms"),
    delivery: getStructureFieldValues(sf, "delivery"),
    withDiscount,
    garment,
  };

  if (sf.some((field) => field.path === "digicode")) {
    adaptedForm.digicode = getStructureFieldValues(sf, "digicode");
  }

  if (sf.some((field) => field.path === "province_code")) {
    adaptedForm.province_code = getStructureFieldValues(sf, "province_code");
  }

  if (sf.some((field) => field.path === "province")) {
    adaptedForm.province = getStructureFieldValues(sf, "province");
  }

  return adaptedForm;
}

const getGarmentSf = (sf) => {
  const arrangement_group = getStructureFieldValues(sf, "arrangement_group");
  arrangement_group.sf = getArrangementGroupSf(arrangement_group.sf);
  return {
    product_type: getStructureFieldValues(sf, "product_type"),
    condition: getStructureFieldValues(sf, "condition"),
    color: getStructureFieldValues(sf, "color"),
    colorDropdown: getStructureFieldValues(sf, "color_dropdown"),
    material: getStructureFieldValues(sf, "material"),
    arrangement_group,
  };
};

const getArrangementGroupSf = (sf) => {
  return {
    arrangement: getStructureFieldValues(sf, "arrangement"),
    message: getStructureFieldValues(sf, "message"),
    arrangement_images: getStructureFieldValues(sf, "arrangement_images"),
    price: getStructureFieldValues(sf, "price"),
    priceWithTaxes: getStructureFieldValues(sf, "priceWithTaxes"),
    priceWithoutDiscount: getStructureFieldValues(sf, "priceWithoutDiscount"),
    discount: getStructureFieldValues(sf, "discount"),
  };
};
